import React from 'react'
import DashboardLayout from '../DashboardLayout'
import Layout from '../Layout'
import MyBidsPanel from '../../../utils/CommonFunctionality/MyBidsPanel'

const MyBids = (props) => {
    return (
        <Layout props={props}>
            <DashboardLayout title="MY BIDS">
                <MyBidsPanel
                    currency="cad"
                    storeTheme="foodindustry"
                    sliderTheme="multiseller"
                    noTimer={true}
                />
            </DashboardLayout>
        </Layout>
    )
}

export default MyBids
